module.exports = __webpack_public_path__ + "../resources/img/ic_pause_light.27558ad1.svg";